module.exports = __webpack_public_path__ + "img/18f2.d91fc309.jpg";